import { render, staticRenderFns } from "./RouterLogicHandler.vue?vue&type=template&id=1404cf94&lang=pug&"
import script from "./RouterLogicHandler.vue?vue&type=script&lang=ts&"
export * from "./RouterLogicHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports